export default __webpack_public_path__ + "static/media/filterIcon.e2ae9d65.svg";